<template>
  <section class="block md:hidden mb-5">
    <div class="bg-white shadow-2l px-4 py-3 rounded-b-lg flex flex-wrap">
      <transition name="slide-fade" >
        <div class="w-full mb-3" v-if="show">
          <div class="description">
            <p
              class="text-gray-600 pb-2 text-sm"
            >
            {{ $store.state.description }}
            </p>
          </div>
          <div class="price rounded p-5 border-2 mt-5">
            <table class="w-full">
              <tbody>
                <tr>
                  <td class="text-gray-700">Subtotal</td>
                  <td class="text-right font-bold text-gray-800">{{ $store.state.price | toCurrency}}</td>
                </tr>
                <tr>
                  <td class="text-gray-700">Entrega</td>
                  <td class="text-right font-bold text-gray-800">{{ $store.state.shipping_amount | toCurrency}}</td>
                </tr>
                <tr class>
                  <td class="text-gray-700">Total</td>
                  <td class="text-right font-bold text-2xl text-gray-800">{{ $store.state.total_price | toCurrency}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </transition>
      <div class="flex w-full">
        <strong class="flex-grow text-2xl">{{ $store.state.total_price | toCurrency}}</strong>
        <button @click="show = !show" class="focus:outline-none bg-indigo-500 rounded-full text-white text-right" type="button">
          <i class="bx bxs-chevron-down bx-lg text-xl p-2" v-if="!show"></i>
          <i class="bx bxs-chevron-up bx-lg text-xl p-2" v-if="show"></i>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      show: false
    }
  }
}
</script>

<style>
</style>
